import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import slide3 from '../aseets/images/home/slide3.jpg';
import { sendContactEmail } from '../services/apiService';
import { useSettings } from '../contexts/SettingsContext';

const Contact = () => {
  const { t } = useTranslation();
  const { settings, isLoading } = useSettings();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  // Valeurs par défaut si les paramètres sont en cours de chargement
  const contactEmail = isLoading ? 'contact@medagricycle.eu' : (settings.email || 'contact@medagricycle.eu');
  const contactPhone = isLoading ? '+00 00 00 00 00' : (settings.phone || '+00 00 00 00 00');
  const facebookUrl = settings.facebook || '#';
  const twitterUrl = settings.twitter || '#';
  const linkedinUrl = settings.linkedin || '#';
  const instagramUrl = settings.instagram || '#';
  const youtubeUrl = settings.youtube || '#';

  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [subjectError, setSubjectError] = useState('');
  const [messageError, setMessageError] = useState('');
  const [submitStatus, setSubmitStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const inputBaseStyle = {
    padding: '12px 15px',
    border: '1px solid #e9ecef',
    borderRadius: '6px',
    fontSize: '0.95rem',
    outline: 'none',
    width: '100%',
    backgroundColor: '#ffffff',
    color: '#212529',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
  };

  const resetInputStyles = () => {
    document.querySelectorAll('.contact-form input, .contact-form textarea').forEach((el) => {
      el.style.borderColor = '';
      el.style.boxShadow = '';
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Réinitialiser les erreurs et le statut
    setNameError('');
    setEmailError('');
    setSubjectError('');
    setMessageError('');
    setSubmitStatus('');
    
    // Validation
    let hasError = false;
    if (!name.trim()) { 
      setNameError(t('contact.errors.nameRequired', 'Le nom est requis')); 
      hasError = true; 
    }
    if (!email.trim()) { 
      setEmailError(t('contact.errors.emailRequired', 'L\'email est requis')); 
      hasError = true; 
    } else if (!/^([^\s@]+)@([^\s@]+)\.[^\s@]+$/.test(email)) { 
      setEmailError(t('contact.errors.emailInvalid', 'Veuillez saisir un email valide')); 
      hasError = true; 
    }
    if (!subject.trim()) { 
      setSubjectError(t('contact.errors.subjectRequired', 'Le sujet est requis')); 
      hasError = true; 
    }
    if (!message.trim()) { 
      setMessageError(t('contact.errors.messageRequired', 'Le message est requis')); 
      hasError = true; 
    } else if (message.trim().length < 10) {
      setMessageError(t('contact.errors.messageTooShort', 'Le message doit contenir au moins 10 caractères')); 
      hasError = true; 
    }

    if (hasError) return;

    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
    resetInputStyles();

    // Envoyer l'email via l'API
    setIsSubmitting(true);
    try {
      const result = await sendContactEmail({ name, email, subject, message });
      
      if (result.success) {
        setSubmitStatus(t('contact.success', 'Merci, votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.'));
        
        // Réinitialiser le formulaire
        setName('');
        setEmail('');
        setSubject('');
        setMessage('');
      } else {
        setSubmitStatus(t('contact.error', 'Une erreur est survenue. Veuillez réessayer.'));
      }
    } catch (error) {
      setSubmitStatus(t('contact.error', error.message || 'Une erreur est survenue lors de l\'envoi. Veuillez réessayer.'));
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
     <style>{`
       .contact-form input,
       .contact-form textarea {
         color: #212529 !important;
         -webkit-text-fill-color: #212529;
       }
       .contact-form input:focus,
       .contact-form textarea:focus {
         border-color: #96ca2d !important;
         box-shadow: 0 0 0 3px rgba(150, 202, 45, 0.15) !important;
         color: #212529 !important;
         -webkit-text-fill-color: #212529;
       }
       .contact-form input:-webkit-autofill,
       .contact-form textarea:-webkit-autofill {
         -webkit-text-fill-color: #212529 !important;
         -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
         box-shadow: 0 0 0 1000px #ffffff inset !important;
       }
       .contact-form__submit {
         display: inline-flex;
         align-items: center;
         gap: 8px;
         padding: 10px 20px;
         border-radius: 25px;
         background: #96ca2d;
         color: #fff;
         border: none;
         font-weight: 600;
         font-size: 0.95rem;
         transition: background 0.3s ease, opacity 0.3s ease;
         cursor: pointer;
       }
       .contact-form__submit:hover:not(:disabled) {
         background: #7ba818;
         color: #fff;
       }
       .contact-form__submit:disabled {
         background: #9ca3af;
         cursor: not-allowed;
         opacity: 0.7;
       }
       @media (max-width: 768px) {
         .contact-section { padding: 16px !important; margin-left: 15px !important; margin-right: 15px !important; }
         .contact-grid { grid-template-columns: 1fr !important; gap: 16px !important; }
         .contact-duo { grid-template-columns: 1fr !important; gap: 12px !important; }
       }
     `}</style>
     <div class="home page-template page-template-page-templates page-template-fullwidth-content page-template-page-templatesfullwidth-content-php page page-id-4059 jet-theme-core jet-theme-core--has-template jet-theme-core--has-header jet-theme-core--has-body jet-theme-core--has-footer layout-fullwidth blog-masonry elementor-default elementor-kit-5747 elementor-page elementor-page-4059"><div id="jet-theme-core-document" class="jet-theme-core-document jet-theme-core-document--elementor-content-type"><div class="jet-theme-core-document__inner">
	
	<Navbar/>
	
	{/* Composant de test des icônes FontAwesome */}
	
	<article id="post-4059" class="post-4059 page type-page status-publish hentry">	
			<div data-elementor-type="wp-page" data-elementor-id="4059" class="elementor elementor-4059">
				<section class="elementor-section elementor-top-section elementor-element elementor-element-ic2p76x elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="ic2p76x" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;5759a04&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
					<div class="elementor-container elementor-column-gap-default">
						<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-im9c73l" data-id="im9c73l" data-element_type="column">
							<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-0bd4fc3 elementor-widget elementor-widget-jet-slider" data-id="0bd4fc3" data-element_type="widget" data-settings="{&quot;slider_height&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:852,&quot;sizes&quot;:[]},&quot;_animation&quot;:&quot;none&quot;,&quot;slider_height_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:650,&quot;sizes&quot;:[]},&quot;slider_height_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:500,&quot;sizes&quot;:[]}}" data-widget_type="jet-slider.default">
									<div class="elementor-widget-container">
										<div class="elementor-jet-slider jet-elements">
											<div style={{ position: 'relative', width: '100%', height: '500px', overflow: 'hidden' }}>
                      <img src={slide3} alt="Contact hero" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
												<div style={{ position: 'absolute', inset: 0, background: 'rgba(0, 0, 0, 0.45)' }} />
												<div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
													<div style={{ background: 'rgba(0,0,0,0.45)', padding: '16px 24px', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.25)', backdropFilter: 'blur(2px)', maxWidth: '960px', width: '100%' }}>
                          <h1 style={{ color: '#fff', fontSize: 'clamp(34px,6vw,56px)', fontWeight: 800, margin: 0, marginBottom: '20px', textAlign: 'center', letterSpacing: '0.5px' }}>{t('contact.heroTitle', 'Contact Us')}</h1>
                          
                          <p style={{ color: 'rgba(255,255,255,0.95)', fontSize: 'clamp(14px,2.5vw,18px)', lineHeight: 1.7, margin: '0 auto 20px', textAlign: 'center', maxWidth: '800px' }}>
                            {t('contact.heroDescription', 'Si vous avez des questions, n\'hésitez pas à nous contacter à')} <a href={`mailto:${contactEmail}`} style={{ color: '#96ca2d', textDecoration: 'underline' }}>{contactEmail}</a>{contactPhone ? ` ${t('contact.heroDescriptionOr', 'ou directement au')} ${contactPhone}` : ''}. {t('contact.heroDescriptionSocial', 'Vous pouvez également nous retrouver sur les réseaux sociaux :')}
                          </p>
                          
                          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '8px' }}>
                            {facebookUrl && facebookUrl !== '#' && (
                              <a href={facebookUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff', fontSize: '24px', textDecoration: 'none', transition: 'all 0.3s ease' }}
                                onMouseEnter={(e) => { 
                                  e.currentTarget.style.color = '#96ca2d';
                                  e.currentTarget.style.transform = 'scale(1.2)';
                                }}
                                onMouseLeave={(e) => { 
                                  e.currentTarget.style.color = '#fff';
                                  e.currentTarget.style.transform = 'scale(1)';
                                }}
                              >
                                <i className="fab fa-facebook-f"></i>
                              </a>
                            )}
                            {twitterUrl && twitterUrl !== '#' && (
                              <a href={twitterUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff', fontSize: '24px', textDecoration: 'none', transition: 'all 0.3s ease' }}
                                onMouseEnter={(e) => { 
                                  e.currentTarget.style.color = '#96ca2d';
                                  e.currentTarget.style.transform = 'scale(1.2)';
                                }}
                                onMouseLeave={(e) => { 
                                  e.currentTarget.style.color = '#fff';
                                  e.currentTarget.style.transform = 'scale(1)';
                                }}
                              >
                                <i className="fab fa-twitter"></i>
                              </a>
                            )}
                            {linkedinUrl && linkedinUrl !== '#' && (
                              <a href={linkedinUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff', fontSize: '24px', textDecoration: 'none', transition: 'all 0.3s ease' }}
                                onMouseEnter={(e) => { 
                                  e.currentTarget.style.color = '#96ca2d';
                                  e.currentTarget.style.transform = 'scale(1.2)';
                                }}
                                onMouseLeave={(e) => { 
                                  e.currentTarget.style.color = '#fff';
                                  e.currentTarget.style.transform = 'scale(1)';
                                }}
                              >
                                <i className="fab fa-linkedin"></i>
                              </a>
                            )}
                            {instagramUrl && instagramUrl !== '#' && (
                              <a href={instagramUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff', fontSize: '24px', textDecoration: 'none', transition: 'all 0.3s ease' }}
                                onMouseEnter={(e) => { 
                                  e.currentTarget.style.color = '#96ca2d';
                                  e.currentTarget.style.transform = 'scale(1.2)';
                                }}
                                onMouseLeave={(e) => { 
                                  e.currentTarget.style.color = '#fff';
                                  e.currentTarget.style.transform = 'scale(1)';
                                }}
                              >
                                <i className="fab fa-instagram"></i>
                              </a>
                            )}
                            {youtubeUrl && youtubeUrl !== '#' && (
                              <a href={youtubeUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff', fontSize: '24px', textDecoration: 'none', transition: 'all 0.3s ease' }}
                                onMouseEnter={(e) => { 
                                  e.currentTarget.style.color = '#96ca2d';
                                  e.currentTarget.style.transform = 'scale(1.2)';
                                }}
                                onMouseLeave={(e) => { 
                                  e.currentTarget.style.color = '#fff';
                                  e.currentTarget.style.transform = 'scale(1)';
                                }}
                              >
                                <i className="fab fa-youtube"></i>
                              </a>
                            )}
                          </div>
                        
</div>
</div>
</div>
</div>


{/* Contact content */}
<section className="elementor-section contact-section" style={{ padding: '30px 16px' }}>
  <div style={{ maxWidth: 1200, margin: '30px auto' }}>
    <div className="contact-grid" style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 24, alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ position: 'relative', maxWidth: '1000px', width: '100%', margin: '0 auto' }}>
        <div 
          style={{
            position: 'absolute',
            top: '-20px',
            left: '-20px',
            width: '40px',
            height: '40px',
            background: '#96ca2d',
            borderRadius: '50%',
            opacity: 0.1
          }}
        />
        <div 
          style={{
            position: 'absolute',
            bottom: '-20px',
            right: '-20px',
            width: '60px',
            height: '60px',
            background: '#96ca2d',
            borderRadius: '50%',
            opacity: 0.1
          }}
        />
        <form
          className="contact-form"
          onSubmit={handleSubmit}
          style={{
            background: '#ffffff',
            borderRadius: 12,
            boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            padding: 20,
            display: 'grid',
            gap: 16,
            height: '100%',
            alignSelf: 'stretch'
          }}
        >
          <div className="contact-duo" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <label style={{ display: 'block', marginBottom: 8, fontWeight: 600,fontSize:"17px", color: '#212529', }}>{t('contact.name', 'Nom')}</label>
              <input
                type="text"
                name="name"
                value={name}
                onChange={(e) => { setName(e.target.value); if (e.target.value.trim()) setNameError(''); }}
                placeholder={t('contact.namePlaceholder', 'Votre nom')}
                style={{ ...inputBaseStyle, border: `1px solid ${nameError ? '#dc3545' : '#e9ecef'}` }}
                onBlur={() => { if (!name.trim()) setNameError(t('contact.errors.nameRequired', 'Le nom est requis')); }}
              />
              {nameError && (<div style={{ color: '#dc3545', fontSize: '0.85rem', marginTop: 4, marginBottom: 8 }}>{nameError}</div>)}
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: 8, fontWeight: 600,fontSize:"17px", color: '#212529' }}>{t('contact.email', 'Email')}</label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => {
                  const val = e.target.value;
                  setEmail(val);
                  if (/^([^\s@]+)@([^\s@]+)\.[^\s@]+$/.test(val)) setEmailError('');
                }}
                placeholder={t('contact.emailPlaceholder', 'Votre email')}
                style={{ ...inputBaseStyle, border: `1px solid ${emailError ? '#dc3545' : '#e9ecef'}` }}
                onBlur={() => {
                  if (!email.trim()) setEmailError(t('contact.errors.emailRequired', "L'email est requis"));
                  else if (!/^([^\s@]+)@([^\s@]+)\.[^\s@]+$/.test(email)) setEmailError(t('contact.errors.emailInvalid', 'Veuillez saisir un email valide'));
                }}
              />
              {emailError && (<div style={{ color: '#dc3545', fontSize: '0.85rem', marginTop: 4, marginBottom: 8 }}>{emailError}</div>)}
            </div>
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: 8, fontWeight: 600,fontSize:"17px", color: '#212529' }}>{t('contact.subject', 'Sujet ')}</label>
            <input
              type="text"
              name="subject"
              value={subject}
              onChange={(e) => { setSubject(e.target.value); if (e.target.value.trim()) setSubjectError(''); }}
              placeholder={t('contact.subjectPlaceholder', 'Sujet de votre message')}
              style={{ ...inputBaseStyle, border: `1px solid ${subjectError ? '#dc3545' : '#e9ecef'}` }}
              onBlur={() => { if (!subject.trim()) setSubjectError(t('contact.errors.subjectRequired', 'Le sujet est requis')); }}
            />
            {subjectError && (<div style={{ color: '#dc3545', fontSize: '0.85rem', marginTop: 4, marginBottom: 8 }}>{subjectError}</div>)}
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: 8, fontWeight: 600,fontSize:"17px", color: '#212529' }}>{t('contact.message', 'Message')}</label>
            <textarea
              name="message"
              value={message}
              onChange={(e) => { 
                const val = e.target.value;
                setMessage(val);
                if (val.trim() && val.trim().length >= 10) {
                  setMessageError('');
                }
              }}
              placeholder={t('contact.messagePlaceholder', 'Votre message')}
              rows={6}
              style={{ ...inputBaseStyle, resize: 'vertical', border: `1px solid ${messageError ? '#dc3545' : '#e9ecef'}` }}
              onBlur={() => { 
                if (!message.trim()) {
                  setMessageError(t('contact.errors.messageRequired', 'Le message est requis'));
                } else if (message.trim().length < 10) {
                  setMessageError(t('contact.errors.messageTooShort', 'Le message doit contenir au moins 10 caractères'));
                }
              }}
            />
            {messageError && (<div style={{ color: '#dc3545', fontSize: '0.85rem', marginTop: 4, marginBottom: 8 }}>{messageError}</div>)}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button
              type="submit"
              className="contact-form__submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                  {t('contact.sending', 'Envoi en cours...')}
                </>
              ) : (
                <>
                  {t('contact.send', 'Envoyer')}
                  <i className="fas fa-arrow-right" style={{ transition: 'transform 0.3s ease' }}></i>
                </>
              )}
            </button>
          </div>

          {submitStatus && (
            <div style={{ 
              marginTop: 12, 
              padding: '12px 16px', 
              background: submitStatus.includes('erreur') || submitStatus.includes('Erreur') ? '#fef2f2' : '#f0f7e6', 
              color: submitStatus.includes('erreur') || submitStatus.includes('Erreur') ? '#991b1b' : '#2f6627', 
              border: `1px solid ${submitStatus.includes('erreur') || submitStatus.includes('Erreur') ? '#fecaca' : '#cfe8a9'}`, 
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              {submitStatus.includes('erreur') || submitStatus.includes('Erreur') ? (
                <i className="fas fa-exclamation-circle"></i>
              ) : (
                <i className="fas fa-check-circle"></i>
              )}
              <span>{submitStatus}</span>
            </div>
          )}
        </form>
      </div>
    </div>
  </div>
</section>
</div>
</div>
</div>
</div>
</div>
</section>
    </div>
</article></div></div></div>

<Footer />

</>
  );
};

export default Contact; 